export const AKA_CC = 'aka-cc'

export const ALREADY_SIGNED = 'already_signed'
export const ALREADY_CLOSED = 'already_closed'
export const ASIAN_FIT_DEFAULT_FILTER = 'AsianFitDefaultFilter'
export const CART_SAVED = 'cartSaved'
export const COUNTRY_OVERLAY_FLAG = 'country_overlay_flag'
export const FB_TRNURL_PDP_PRIVATESALE = 'fb_trnurl_pdp_privatesale'
export const IMAGE_CONSENT = 'ImageConsent'
export const MINIWISHLIST_SAVED = 'miniWhislistSaved'
export const PUSH_NOTIFICATION_SEEN = 'push_notification_seen'
export const RB_SRCH_TERMS = 'RBSrchTerms'
export const ROE_CC = 'roe-cc'
export const SET_CURRENCY = 'set-currency'
export const STICKY_BAR_TOOLTIP_CLOSED = 'stickyBarTooltipClosed'
export const STICKY_BAR_CONTENT_TOOLTIP_IS_IN_PAGE = 'stickyBarContentTooltipIsInPage'
export const VM_ACTIVE = 'vm-active'
export const WC_SESSION_ESTABLISHED = 'WC_SESSION_ESTABLISHED'
export const NOECOMM_CC = 'NOECOMM_CC'
export const IS_CSR = 'isCSRSession'
export const CH_CART_SAVED = 'ch_cartSaved'
export const GENESYS_CHAT_WAS_INITIALIZED = 'genesysChatWasInitialized'
export const TRACKING_CART = 'trackingCart'
export const ZERO_EXPIRE_VALUE = '0'
